/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteMarketplaceItemListingResponse } from '../../models/delete-marketplace-item-listing-response';

export interface MarketplaceServiceDeleteMarketplaceItemListing$Params {
  marketplaceListingId: string;
  discordId?: string;
  userUuid?: string;
}

export function marketplaceServiceDeleteMarketplaceItemListing(http: HttpClient, rootUrl: string, params: MarketplaceServiceDeleteMarketplaceItemListing$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteMarketplaceItemListingResponse>> {
  const rb = new RequestBuilder(rootUrl, marketplaceServiceDeleteMarketplaceItemListing.PATH, 'delete');
  if (params) {
    rb.path('marketplaceListingId', params.marketplaceListingId, {});
    rb.query('discordId', params.discordId, {});
    rb.query('userUuid', params.userUuid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteMarketplaceItemListingResponse>;
    })
  );
}

marketplaceServiceDeleteMarketplaceItemListing.PATH = '/api/v3/gateway/marketplace/listing/{marketplaceListingId}';
